<!-- 登录情况 -->
<template>
  <Card :bordered="false" dis-hover>
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <a href="#" slot="extra"><slot name="extra"></slot></a>
    <div class="login-status">
      <div class="login-data">
        <div class="data-top">
          <count-to
            :end="loginData.yesterdayCount"
            count-class="count-style color-green"
          />
          <span class="count-label">{{ $t('home.user_login') }}</span>
        </div>
        <div class="data-top">
          <count-to
            :end="loginData.yesterdayNoCount"
            count-class="count-style color-red"
          />
          <span class="count-label">{{ $t('home.user_unlogin') }}</span>
        </div>
      </div>
      <div class="data-bottom">
        <count-to :end="loginData.total" count-class="count-style" />
        <span class="count-label">{{ $t('home.user_total') }}</span>
      </div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import CountTo from '../../../components/count-to/index';
import moment from 'moment';
export default {
  components: { CountTo },
  data() {
    return {
      loginData: {
        yesterdayCount: 0,
        yesterdayNoCount: 0,
        total: 0,
      },
    };
  },
  /*computed:{
    data(){
    
    }
  },*/
  created() {
    this.getData();
  },
  methods: {
    getData() {
      api
        .countLogsNew({
          startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        })
        .then(res => {
          if (res) {
            this.loginData = res;
          }
        })
        .catch(error => {
          console.error(`${this.$t('home.error_getlogindatav')}:${error}`);
        });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.login-status {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .login-data {
    display: flex;
    justify-content: space-between;
    .data-top {
      width: 48%;
      height: 108px;
      text-align: center;
      margin: 10px 0;
      background: #f7f7f7;
      border-radius: 8px;
      padding: 22px 0;
    }
  }
  .data-bottom {
    margin: 0 auto;
    margin-top: 12px;
    width: 100%;
    height: 98px;
    text-align: center;
    background: #f7f7f7;
    border-radius: 8px;
    padding: 22px 0;
  }
}
</style>
